<template>
  <section v-if="steps.length" class="offer-steps">
    <h3 class="offer-steps__title">{{ title }}</h3>
    <ol class="offer-steps__list">
      <li v-for="(step, i) in steps" :key="step.title" class="offer-steps__step" :class="`offer-steps__step--${step.state || 'next'}`">
        <span class="offer-steps__marker" aria-hidden="true">
          <svg v-if="step.state === 'done'" viewBox="0 0 16 16" fill="none"><path d="M3.5 8.5l3 3 6-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
          <template v-else>{{ i + 1 }}</template>
        </span>
        <span class="offer-steps__text">
          <strong>{{ step.title }}</strong>
          <span>{{ step.text }}</span>
        </span>
      </li>
    </ol>
  </section>
</template>

<script>
/**
 * A deal's steps in order, each done, current or still to come: an offer's timeline, or how a
 * book-built offer works. The page decides the steps; this only draws them.
 */
export default {
  name: "OfferSteps",
  props: {
    title: { type: String, required: true },
    // [{ title, text, state: "done" | "current" | "next" }]
    steps: { type: Array, default: () => [] },
  },
};
</script>

<style lang="scss" scoped>
$text-primary: #0f172a;
$text-secondary: #475569;
$border-color: #e2e8f0;
$accent: #4d84ff;
$success: #10b981;

.offer-steps {
  background: #ffffff;
  border: 1px solid $border-color;
  border-radius: 12px;
  padding: 20px;

  &__title {
    font-size: 15px;
    font-weight: 600;
    color: $text-primary;
    margin: 0 0 14px;
  }

  &__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 16px;
    @media (max-width: 767px) { grid-template-columns: 1fr; }
  }

  &__step {
    display: flex;
    gap: 10px;
    align-items: flex-start;
  }

  &__marker {
    flex: none;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    border: 1.5px solid $border-color;
    color: $text-secondary;
    background: #ffffff;
    svg { width: 14px; height: 14px; }
  }

  &__step--done &__marker { background: $success; border-color: $success; color: #ffffff; }
  &__step--current &__marker { background: $accent; border-color: $accent; color: #ffffff; }

  &__text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 13px;
    line-height: 1.45;
    color: $text-secondary;
    strong { color: $text-primary; font-weight: 600; }
  }
}
</style>
